export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_PUSH_NOTIFICATIONS = 'mpn';
export const HYDRA_OOSM = 'oosm'; // [O]ut [O]f [S]tock [M]obile
export const HYDRA_CHECKOUT_SHIP_SECTION_ADJUSTMENT = 'cssa'; // [C]heckout [S]hip [S]ection [A]djustment
export const HYDRA_BRAND_NAME_SEARCH = 'bnsr'; // [B]rand [N]ame [S]ea[R]ch
export const HYDRA_SEARCH_COLOR_SWATCHES = 'crss'; // Search [C]olo[r] [S]watche[s]
export const HYDRA_PLACEBO_SEARCH = 'posh'; // [P]laceb[o] [S]earc[h]
export const HYDRA_PLACEBO_PDP = 'popp'; // [P]laceb[o] [P]roduct [P]age
export const HYDRA_PDP_PRODUCT_ANGLES = 'pdng'; // [PD]P Product a[NG]les
export const HYDRA_6PM_MARTY_RETURNS = '6mrt'; // [6]pm [M]arty [R]e[t]urns
export const HYDRA_STREAM_RESPONSE = 'strm'; // Response [Str]ea[m]ing
export const HYDRA_CHECKOUT_SHIPPING_DOWNGRADE = 'csd'; // [C]heckout [S]hipping [D]owngrade
export const HYDRA_FONT_PRELOAD = 'fp'; // [F]ont [P]reload
export const HYDRA_CROSS_SITE_SELLING = 'xsll'; // [X]Cross Site [S]e[l][l]ing
export const HYDRA_SEO_H1_TITLE_COPY = 'shtc'; // [S]EO [H]1 [T]itle [C]opy
export const HYDRA_SEO_COPY_LOCATION = 'scop'; // [S]EO [Co]py [P]osition
export const HYDRA_6PM_ADSENSE = 'sad'; // [S]ixPM [Ad]sense
export const HYDRA_6PM_ADSENSE_LP_HF = 'lpad'; // 6pm [L]anding [P]age [Ad]s
export const HYDRA_PDP_FEEDBACK = 'pdfb'; // [P]roduct [D]etail [F]eed[B]ack
export const HYDRA_6PM_DISPLAY_ADS = 'dad'; // 6pm [D]isplay [Ad]s
export const HYDRA_6PM_DISPLAY_IFRAME_ADS = 'dadi'; // 6pm [D]isplay [Ad]s [i]Frame
export const HYDRA_VIP_DASHBOARD = 'vda'; // [V]ip [Da]shboard; rebrand of Rewards -> VIP
export const HYDRA_PERSONALIZED_SIZING_ROUNDER = 'prsr'; // [P]e[R]sonalized [S]izing [R]ounder
export const HYDRA_PERSONALIZED_CATEGORIES = 'cats'; // Personalized [CAT]egorie[S];
export const HYDRA_CHECKOUT_STICKY_PLACE_ORDER = 'cspo'; // Sticky Place Order
export const HYDRA_DOUBLE_PRODUCT_REMOVE = 'dz0s'; // [D]ouble [Z]appos [0S]
export const HYDRA_PDP_ODSP_LINK_CHANGE = 'polc'; // [P]roduct Page [O]DSP [L]ink [C]hange
// And now also includes buybox unrecognized size reco https://github01.zappos.net/mweb/marty/issues/9723
export const HYDRA_FEDERATED_LOGIN = 'fed'; // [Fed]erated Login
export const HYDRA_SAVE_AND_APPLY_FILTERS = 'savi'; // [Sa]ve and apply f[I]lters
export const HYDRA_VIP_RENDER_ACTIVITY = 'vra'; // [V]ip [R]ender [A]ctivity
export const HYDRA_FEWER_PRODUCT_IMAGES = 'fpi'; // [F]ewer [P]roduct [I]mages
export const HYDRA_INTERSTITIAL_CART_UPSELL = 'icup'; // [I]nterstitial [C]art [UP]sell
export const HYRDA_MINIFIED_MOBILE_HEADER = 'mdma'; // [M]inify [D]a [M]oble  he[A]der
export const HYDRA_SEARCH_SPELLCHECK = 'seas'; // [SEA]rch [S]pellcheck
export const HYDRA_IMAGES_BY_ZYCADA = 'izy'; // [I]mages By [Zy]cada
export const HYDRA_SEARCH_SIZE_COLLAPSE = 'sico'; // search [Si]ze [Co]llapse
export const HYDRA_SEARCH_SINGLE_SHOE = 'earn'; // s[EAR]ch si[N]gle shoe
export const HYDRA_EXCHANGE_FEATURE_REWORK = 'efr'; // [E]xchange [F]eature [R]ework
export const HYDRA_REVIEW_INCENTIVE = 'rice'; // [R]eview [I]n[CE]ntive
export const HYDRA_CHECKOUT_REMOVE_PAYMENT_ON_ORDER = 'crpo'; // [C]heckout [R]emove [P]ayment on [O]rder
export const HYDRA_FREE_PHONE = 'frep'; // [Fre]e [P]hone
export const HYDRA_CHECKOUT_NO_PAYMENT_MSG = 'cnpm'; // [C]heckout No Payment Message
export const HYDRA_EDITORIAL_SEARCH_PLACEMENTS = 'edsp'; // [ED]itorial [S]earch [P]lacements
export const HYDRA_HD_SEARCH_IMAGES = 'hdsi'; // [HD] [S]earch [I]mages
export const HYDRA_CHECKOUT_EXPAND_REVIEW_ITEMS = 'ceri'; // [C]heckout [E]xpand [R]eview [I]tems
export const HYDRA_PERSONALIZED_SEARCH_UNRECOGNIZED = 'psbs';
export const HYDRA_WEAKER_SORT_BEST_SELLER = 'wsbs';
export const HYDRA_WEAKER_SORT_NEW_ARRIVALS = 'wsna';
export const HYDRA_PRIME_TWO_DAY_SHIPPING = 'ptds'; // [P]rime [T]wo [D]ay [S]hipping
export const HYDRA_AUTO_CHECK_VIP = 'acv'; // [A]uto [C]heck [V]ip
export const HYDRA_CHECKOUT_VIP_ONE_DAY_SHIPPING = 'cvod'; // [C]heckout [V]IP [O]ne [D]ay Shipping
